Apt.fn.make('account.password', {
	/**
	 * Initialize module
	 */
	init() {
		LS.api.bind('$passwordForm', 'me/password', {
			namespace: 'password',
			method: 'patch',
			success: () => {
				$.history.go('/account');
			}
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		$.events.reset('password');
	}
});